import medalImage from "@assets/icon/medal.png";
import { useState } from "react";
import { ModalPremium } from "./ModalPremium";
import { Donation } from "@entities/donation";
import { useGetMyAcceptedDonation } from "@features/donation/get-latest-accepted-donation";
import { ButtonLoader } from "@components/loader/button-loader";
import { ButtonError } from "@components/http-error";


interface PremiumBadgeProps {
  // getNewestDonation: () => Promise<Donation>
}

export function PremiumBagde(props: PremiumBadgeProps){

  const [isModalOpen, setIsOpenModalOpen] = useState(false); 
  const [licenceKey, setLicenceKey] = useState("Loading.....");
  const {data, isPending, error} = useGetMyAcceptedDonation();

  async function handleButtonOnClick(){
    setIsOpenModalOpen(!isModalOpen);
  }

  if(isPending) return <ButtonLoader />
  if(error) return <ButtonError error={error} />

  if(!data?.length) return null;

  return (
    <>
    <button 
      onClick={handleButtonOnClick}
      className="border border-warning  hover:bg-warning/90 active:bg-warning/80 inline-flex items-center gap-3 px-5 py-1.5 rounded-full text-white transition-all">
      <img src={medalImage as string} alt="" />
      Premium
    </button>

    <ModalPremium 
      licenceKey={data[0]?.licenceKey!}
      isModalOpen={isModalOpen}
      setIsModalOpen={() => setIsOpenModalOpen(!isModalOpen)}
     />
    </>
  )
}